export default __webpack_public_path__ + "static/media/avatar.4a85a600.jpg";